import React from 'react';
import './scss/collection-image.scss';
import './scss/filter-sidebar.scss';

function FilterSidebar():React.ReactElement {
  return (
    <div id="sidebar" className="collapse-horizontal border-end collapse pt-3">
      <div id="sidebar-nav" className="border-0 rounded-0 text-sm-start min-vh-100">
        <div className="d-block pb-2">
          <h6 className="text-uppercase d-inline">Chain</h6>
        </div>
        <p className="mb-2">
          <a href="/">Binance</a>
        </p>
        <p className="mb-2">
          <a href="/" className="mb-1">Ethereum</a>
        </p>
        <div className="d-block pb-2 pt-4">
          <h6 className="text-uppercase d-inline">
            Categories
          </h6>
        </div>
        <p className="mb-2"><a href="/" className="mb-1">Art</a></p>
        <p className="mb-2">
          <a href="/" className="mb-1">Sports</a>
        </p>
        <p className="mb-2">
          <a href="/" className="mb-1">Collectibles</a>
        </p>
        <p className="mb-2"><a href="/" className="mb-1">Gaming</a></p>
        <p className="mb-2">
          <a href="/" className="mb-1">Entertainment</a>
        </p>
        <p className="mb-2"><a href="/" className="mb-1">Sports</a></p>
        <p className="mb-2"><a href="/" className="mb-1">EDS NFTs</a></p>
        <span
          style={{ height: '0px' }}
          data-bs-parent="#sidebar"
          className="border-end-0 d-inline-block text-truncate"
        />
      </div>
    </div>
  );
}

export default FilterSidebar;
